export function slickDefaults(settings) {
  const btnHtml =
    `<button class="btn btn-nav slick-:dir" type="button">
      <svg class="icon">
        <use xlink:href="#:icon" />
      </svg>
    </button>`;

  return Object.assign({
    rows: 0,
    infinite: false,
    prevArrow: btnHtml.replace(':dir', 'prev').replace(':icon', 'chevron-left'),
    nextArrow: btnHtml.replace(':dir', 'next').replace(':icon', 'chevron-right')
  }, settings);
}
